/**
 * The level animals as pixel sprites — one JSON per level (1–31), drawn in one style
 * (sources + drawing tools: scripts/level-sprites/). Each file is its own lazy chunk,
 * fetched only when that animal is shown, so none of it touches the critical path.
 *
 * Sprite: { level, w, h, palette: {char: hex}, idle[2], move[4], action[2], say }
 * where every frame is `h` strings of `w` chars ('.' = transparent), facing left.
 */
const loaders = import.meta.glob('./level-*.json', { import: 'default' });

/** @returns {Promise<object|null>} the sprite for a level, or null if there isn't one */
export function loadLevelSprite(level) {
  const load = loaders[`./level-${String(level).padStart(2, '0')}.json`];
  return load ? load() : Promise.resolve(null);
}
